import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import VendorHeader from "./../component/VendorHeader";
import VendorFooter from "./../component/VendorFooter";
import $ from "jquery";
import { API_BASE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import Sidebar from "../component/Sidebar";
import PayPalPayment from "./PayPalPayment";
import { NotificationManager } from "react-notifications";

const icon1 = require("./../assets/img/dashboard-icon.svg").default;
const icon2 = require("./../assets/img/info-icon.svg").default;
const icon3 = require("./../assets/img/app-icon.svg").default;
const icon4 = require("./../assets/img/payment-icon.svg").default;
const icon5 = require("./../assets/img/store-icon.svg").default;
const icon6 = require("./../assets/img/list-icon.svg").default;
const icon7 = require("./../assets/img/order-icon.svg").default;
const icon8 = require("./../assets/img/plan-icon.svg").default;
const icon9 = require("./../assets/img/logout-icon.svg").default;
const deleteIcon = require("./../assets/img/delete-icon.svg").default;

const PlanSubscription = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { user, setUser } = useAuth();
  const { langJson } = useLanguage();

  const [formData, setFormData] = useState({
    email: "",
    company: "",
    firstName: "",
    salutation: "",
    phone: "",
    address: "",
    country: "",
    city: "",
    state: "",
    federalState: "",
    zipCode: "",
    taxID: "",
    paymentTerms: "",
    shippingTerms: "",
    tax: "",
    termsAggreed: true,
    selectedPricing: "",
    couponCode: "",
    selectedPayment: "",
    finaltermsAggreed: true,
    accountHolder: "",
    accountIBAN: "",
    accountBIC: "",
  });
  const [signupStatus, setSignupStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState();
  const [ibanError, setIbanError] = useState("");

  const handleChange = event => {
    const { name, value } = event.target;

    setFormData(prevData => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "accountIBAN") {
      setIbanError("");
    }
  };

  const validateIBAN = (iban) => {
    iban = iban.replace(/\s/g, "").toUpperCase();
    const ibanRegex = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/;
    return ibanRegex.test(iban);
  };

  const handleSubmit = async () => {
    const isFreeplan = parseFloat(selectedPlan?.price) === 0;

    if (!isFreeplan && !formData.selectedPayment) {
      setSignupStatus(langJson?.pleasechoosePaymentMethod);
      return;
    }

    if (formData.selectedPayment === 2 && parseFloat(selectedPlan?.price) > 0) {
      if (!formData.accountHolder || !formData.accountIBAN || !formData.accountBIC) {
        setSignupStatus(langJson?.pleaseenterbankaccountdetails);
        return;
      }
      if (!validateIBAN(formData.accountIBAN)) {
        setIbanError("Invalid IBAN format");
        setSignupStatus("Invalid IBAN format");
        return;
      }
    }

    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}stores/update-plan`, {
        method: "POST",
        body: JSON.stringify({
          plan_id: id,
          amount: (parseFloat(selectedPlan?.price) + (parseFloat(selectedPlan?.price) * 19) / 100).toFixed(2),
          payment_method: isFreeplan ? "Free" : (formData.selectedPayment === 1 ? "PayPal" : "Direct Debit"),
          coupon_code: formData.couponCode ? formData.couponCode : "",
          account_holder: formData.accountHolder ? formData.accountHolder : "",
          iban: formData.accountIBAN ? formData.accountIBAN : "",
          bic: formData.accountBIC ? formData.accountBIC : "",
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setSignupStatus(responseData.msg);
        NotificationManager.success(responseData.msg);
        navigate("/dashboard");
        setLoading(false);
      } else {
        setSignupStatus(responseData.msg);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error during Sign UP:", error);
      setLoading(false);
    }
  };

  const fetchPlanDetails = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}frontend/plans`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        let tempSelItem = responseData.data.find(item => parseInt(item?.id) === parseInt(id));
        setSelectedPlan(tempSelItem);
      } else {
      }
    } catch (error) { }
  };

  useEffect(() => {
    fetchPlanDetails();
  }, []);

  return (
    <div>
      <div className="dashHeader">
        <VendorHeader />
      </div>
      <div className="adminDash">
        <Sidebar />
<div className="rightSide rightTop">
          <div className="plansDiv">
            <h2 style={{ textAlign:"center", width: "100%" }}>{selectedPlan?.name} Plan</h2>
            <p className="planPrice">EUR {selectedPlan?.price}</p>
          </div>
          <div className="chooseDiv planSub">
            <div className="rightSide">
              <ul className="addAddress">
                {/* <li>
                  <label>{langJson?.emailaddress}:</label>
                  <input type="text" name="email" value={formData.email} readOnly onChange={handleChange} />
                </li>
                <li>
                  <label>{langJson?.companyname}:</label>
                  <input type="text" name="company" value={formData.company} onChange={handleChange} />
                </li>
                <li>
                  <label>{langJson?.salutation}:</label>
                  <select name="salutation" value={formData.salutation} onChange={handleChange}>
                    <option selected hidden>
                      Select
                    </option>
                    <option value={"Mr."}>Mr.</option>
                    <option value={"Mrs."}>Mrs.</option>
                  </select>
                </li>
                <li>
                  <label>{langJson?.fullname}:</label>
                  <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} />
                </li>
                <li>
                  <label>{langJson?.address}:</label>
                  <input type="text" name="address" value={formData.address} onChange={handleChange} />
                </li>
                <li>
                  <label>{langJson?.zipcode}:</label>
                  <input type="text" name="zipCode" value={formData.zipCode} onChange={handleChange} />
                </li>
                <li>
                  <label>{langJson?.city}:</label>
                  <input type="text" name="city" value={formData.city} onChange={handleChange} />
                </li>
                <li>
                  <label>{langJson?.state}:</label>
                  <input type="text" name="state" value={formData.state} onChange={handleChange} />
                </li>
                <li>
                  <label>{langJson?.country}:</label>
                  <input type="text" name="country" value={formData.country} onChange={handleChange} />
                </li>
                <li>
                  <label>{langJson?.phonefaxmobilenumber}:</label>
                  <input type="text" name="phone" value={formData.phone} onChange={handleChange} />
                </li>
                <li className="sizeInput">
                  <label>{langJson?.taxid}:</label>
                  <input type="text" name="taxID" value={formData.taxID} onChange={handleChange} />
                </li>
                <li className="fullWidth checkPlan">
                  <input type="checkbox" checked={formData.termsAggreed} onChange={e => setFormData(prev => ({...prev, termsAggreed: e.target.checked}))} />{" "}
                  {langJson?.iagreedtermsinplan}
                </li> */}
                {/* <li className="fullWidth algnLf">
                  <h3>Pricing</h3>
                </li>
                <li className="fullWidth algnLf" onClick={() => setFormData(prev => ({...prev, selectedPayment: 1}))}>
                  <input type="radio" name="pricingType" checked={formData?.selectedPayment === 1} /> The monthly portal rent is € 19.90 net + 19% VAT (€ 1.88)
                  = gross € 11.78
                </li>
                <li className="fullWidth" onClick={() => setFormData(prev => ({...prev, selectedPayment: 2}))}>
                  <input type="radio" name="pricingType" checked={formData?.selectedPayment === 2} /> The monthly portal rent is € 19.90 net + 19% VAT (€ 3.78)
                  = gross € 23.68
                </li> */}
                <li className="fullWidth algnLf">
                  <h4>
                    {selectedPlan?.price ? (
                      langJson?.monthlyportalrent?.replace(
                        /{price}|{vat}|{gross}/g,
                        (match) => {
                          const vat = ((parseFloat(selectedPlan?.price) * 19) / 100).toFixed(2);
                          const gross = (parseFloat(selectedPlan?.price) + parseFloat(vat)).toFixed(2);
                          return match === '{price}' ? selectedPlan?.price : match === '{vat}' ? vat : gross;
                        }
                      )
                    ) : null}
                  </h4>
                </li>
                <li className="fullWidth algnLf">
                  <h5>{langJson?.couponcodepromotioncode}</h5>
                </li>
                <li className="fullWidth entrCoupon">
                  {langJson?.entercouponcode}{" "}
                  <input type="text" value={formData?.couponCode} onChange={e => setFormData(prev => ({ ...prev, couponCode: e.target.value }))} />
                  {langJson?.tohaveafreemonth}
                </li>

                {formData?.selectedPayment === 1 ? (
                  <>
                    <li className="fullWidth algnLf">
                      <PayPalPayment paymentMethod={"Paypal"} />
                      {/* <PayPalPayment storeId={storeId} shippingId={shippingId} paymentMethod={"Paypal"} productPrice={allDetails} /> */}
                    </li>
                  </>
                ) : null}
                {parseFloat(selectedPlan?.price) > 0 ? (
                  <>
                    <li className="fullWidth algnLf">
                      <h5>{langJson?.payment}</h5>
                    </li>
                    <li className="fullWidth algnLf entrCoupon">
                      <input
                        type="radio"
                        name="paymentType"
                        checked={formData?.selectedPayment === 1}
                        onClick={() => setFormData(prev => ({ ...prev, selectedPayment: 1 }))}
                      />
                      <div className="payPalDiv">{langJson?.paypal}</div>
                    </li>
                    <li className="fullWidth">
                      <input
                        type="radio"
                        name="paymentType"
                        checked={formData?.selectedPayment === 2}
                        onClick={() => setFormData(prev => ({ ...prev, selectedPayment: 2 }))}
                      />
                      {langJson?.paymentbydirectdebitfromagermanbankaccount}
                    </li>
                    {formData?.selectedPayment === 2 ? (
                      <>
                        <li className="sizeInput">
                          <label>{langJson?.accountholder}:</label>
                          <input type="text" name="accountHolder" value={formData.accountHolder} onChange={handleChange} />
                        </li>
                        <li className="sizeInput">
                          <label>{langJson?.iban}:</label>
                          <input
                            type="text"
                            name="accountIBAN"
                            value={formData.accountIBAN}
                            onChange={handleChange}
                            placeholder="e.g. DE89 3704 0044 0532 0130 00"
                            style={{ borderColor: ibanError ? "red" : "" }}
                          />
                          {ibanError && <span style={{ color: "red", fontSize: "12px" }}>{ibanError}</span>}
                        </li>
                        <li className="sizeInput">
                          <label>{langJson?.bic}:</label>
                          <input type="text" name="accountBIC" value={formData.accountBIC} onChange={handleChange} />
                        </li>
                      </>
                    ) : null}
                  </>
                ) : null}

                <li className="fullWidth" style={{ paddingBottom: '20px' }}>
                  <h4 style={{ marginBottom: '10px', fontWeight: '600' }}>{langJson?.contract_section_term}</h4>
                  <p style={{ marginBottom: '15px', fontSize: '14px', lineHeight: '1.6' }}>{langJson?.contract_term_text}</p>

                  <h4 style={{ marginBottom: '10px', fontWeight: '600' }}>{langJson?.contract_section_content}</h4>
                  <p style={{ marginBottom: '15px', fontSize: '14px', lineHeight: '1.6' }}>{langJson?.contract_content_text}</p>

                  <h4 style={{ marginBottom: '10px', fontWeight: '600' }}>{langJson?.contract_section_sepa}</h4>
                  <p style={{ marginBottom: '15px', fontSize: '14px', lineHeight: '1.6' }}>{langJson?.contract_sepa_text}</p>

                  <h4 style={{ marginBottom: '10px', fontWeight: '600' }}>{langJson?.contract_section_privacy}</h4>
                  <p style={{ marginBottom: '20px', fontSize: '14px', lineHeight: '1.6' }}>{langJson?.contract_privacy_text}</p>
                </li>
                <li className="fullWidth checkPlan">
                  <input
                    type="checkbox"
                    checked={formData.finaltermsAggreed}
                    onChange={e => setFormData(prev => ({ ...prev, finaltermsAggreed: e.target.checked }))}
                  />{" "}
                  <span style={{ fontSize: '14px' }}>{langJson?.contract_final_confirmation}</span>
                </li>
                <li className="fullWidth saveBtn">
                  <button type="submit" disabled={loading} onClick={() => handleSubmit()}>
                    {/* {loading ? langJson?.pleasewait : langJson?.savechanges} */}
                    {loading ? langJson?.pleasewait : langJson?.submit}
                  </button>
                </li>
                <span className="lgnStatus">{signupStatus}</span>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <VendorFooter />
    </div>
  );
};

export default PlanSubscription;
